import { Box, Flex, HStack, Icon, VStack } from "@chakra-ui/react"
import { StepsWhyJourney } from "@data/steps"
import { useTranslations } from "next-intl"

export default function Journey() {
  const t = useTranslations("why")

  return (
    <Flex
      justify={"space-around"}
      mt={100}
      flexWrap={"wrap"}
    >
      {StepsWhyJourney.map((step, index) => (
        <VStack
          key={index}
          borderColor={"gray.100"}
          borderWidth={2}
          borderRadius={8}
          width={{ base: "full", sm: 300, xl: 380 }}
          align={"flex-start"}
          p={4}
          my={2}
        >
          <HStack
            spacing={0}
            width={"full"}
            justify={"space-between"}
          >
            <Box
              fontSize={"7xl"}
              color={"gray.300"}
            >
              {index + 1}
              {"."}
            </Box>
            <Icon
              as={step.icon}
              w={32}
              h={32}
            ></Icon>
          </HStack>

          <VStack
            spacing={0}
            align={"flex-start"}
          >
            <Box
              textTransform={"capitalize"}
              color={
                StepsWhyJourney.length - 1 === index
                  ? "brand.primary"
                  : "brand.black"
              }
              fontWeight={StepsWhyJourney.length - 1 === index ? "700" : "400"}
            >
              {t(step.title)}
            </Box>
          </VStack>
        </VStack>
      ))}
    </Flex>
  )
}
